import type { FetchOfficeSearchConfig, OfficeSearchQueryParams } from "./types";

const DEFAULT_CONFIG = {
  apiEndpoint: "/api/fawkes/office-search",
};

/**
 * Fetches nearby offices for a geo search term (general office search, not hiring).
 */
async function fetchOfficeSearch(
  {
    location,
    radius = 30,
    forceProximitySearch = false,
  }: OfficeSearchQueryParams,
  { apiEndpoint }: FetchOfficeSearchConfig = DEFAULT_CONFIG,
) {
  if (!location || location.trim() === "") {
    throw new Error("Location is required");
  }

  const searchParams = new URLSearchParams({
    query: location,
  });

  if (forceProximitySearch) {
    searchParams.set("forceProximitySearch", "true");
    searchParams.set("miles", radius.toString());
  }

  let result;
  try {
    const response = await fetch(`${apiEndpoint}?${searchParams}`);

    if (!response.ok) {
      throw new Error(
        `Failed to fetch offices: ${response.status} ${response.statusText}`,
      );
    }

    result = await response.json();
  } catch (error) {
    console.error(error);
    throw new Error("Error fetching offices");
  }

  if (!result.success) {
    throw new Error(result.message || "Error fetching offices");
  }

  return result.data;
}

export { fetchOfficeSearch };
